"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppThemeProvider = exports.useAppThemeContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const UserSettingsStorage_1 = require("src/configeek_assets/src/components/common/provider/UserSettingsStorage");
const index_1 = require("src/configeek_assets/src/system/theme/themes/index");
const DynamicThemeSuspenseWrapper_1 = require("src/configeek_assets/src/system/theme/DynamicThemeSuspenseWrapper");
const useMediaQuery_1 = require("src/configeek_assets/src/system/hooks/useMediaQuery");
const defaultThemeIdOnStart = UserSettingsStorage_1.userSettingsStorage.theme;
// console.log("defaultThemeIdOnStart", defaultThemeIdOnStart);
const defaultTheme = index_1.themes[defaultThemeIdOnStart];
const AppThemeContext = React.createContext(undefined);
const useAppThemeContext = () => {
    const context = React.useContext(AppThemeContext);
    if (!context) {
        throw new Error("useAppThemeContext must be used within a AppThemeContext.Provider");
    }
    return context;
};
exports.useAppThemeContext = useAppThemeContext;
const AppThemeProvider = (props) => {
    const [themeId, setThemeId] = (0, react_1.useState)(defaultTheme.id);
    const selectThemeId = (0, react_1.useCallback)((value) => {
        setThemeId(value);
        UserSettingsStorage_1.userSettingsStorage.theme = value;
        // Analytics.UserProfile.setTheme(value)
    }, []);
    const isDarkTheme = themeId == "dark";
    const isSystemDarkModeOn = (0, useMediaQuery_1.useMediaQuery)("(prefers-color-scheme: dark)");
    (0, react_1.useEffect)(() => {
        if (isSystemDarkModeOn) {
            document.getElementById("faviconLink").href = "/favicon-64-dark_v2.svg";
        }
        else {
            document.getElementById("faviconLink").href = "/favicon-64_v2.svg";
        }
    }, [isSystemDarkModeOn]);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        themeId,
        selectThemeId,
        isDarkTheme,
    }), [
        themeId,
        selectThemeId,
        isDarkTheme,
    ], lodash_1.default.isEqual);
    return React.createElement(AppThemeContext.Provider, { value: value },
        React.createElement(DynamicThemeSuspenseWrapper_1.DynamicThemeSuspenseWrapper, { themes: index_1.themes, value: themeId }, props.children));
};
exports.AppThemeProvider = AppThemeProvider;
